export default __webpack_public_path__ + "static/media/designTablet.60b558a5.webp";